import React from 'react';
import './MobileView.scss';

interface MobileViewProps {
  children: React.ReactNode;
}

const MobileView: React.FC<MobileViewProps> = ({ children }) => {
  return (
    <div className="mobile-wrapper">
      <div className="mobile-content">
        {children}
      </div>
    </div>
  );
};

export default MobileView;